<template>
  <div class="footerNavBox">
    <div @click="onSwitch('/')">
      <van-icon 
        :style="{ color: curPath === '/' ? '#ff0000' : '' }"
        name="wap-home-o" 
        size="0.8rem" 
      />
      <div :style="{ color: curPath === '/' ? '#ff0000' : '' }">询价项目</div>
    </div>
    <div @click="onSwitch('/myOffer')">
      <van-icon 
        :style="{ color: curPath === '/myOffer' ? '#ff0000' : '' }"
        name="notes-o" 
        size="0.8rem" 
      />
      <div :style="{ color: curPath === '/myOffer' ? '#ff0000' : '' }">我的报价</div>
    </div>
     <div @click="onSwitch('/message')">
      <van-icon 
        :style="{ color: curPath === '/message' ? '#ff0000' : '' }"
        name="chat-o" 
        size="0.8rem" 
      />
      <div :style="{ color: curPath === '/message' ? '#ff0000' : '' }">消息</div>
    </div>
     <div @click="onSwitch('/my')">
      <van-icon 
        :style="{ color: curPath === '/my' ? '#ff0000' : '' }"
        name="manager-o" 
        size="0.8rem" 
      />
      <div :style="{ color: curPath === '/my' ? '#ff0000' : '' }">我的</div>
    </div>
  </div>
</template>

<script>
export default {
  data() { 
    return { 
      curPath: ''
    }
  },
  activated() {
    this.curPath = this.$route.path; // 当路由切换时，更新 curPath 的值为当前路由的路径
  },
  methods: {
    onSwitch(path) { // 点击切换路由的方法
      this.$router.push({ path }); // 使用 $router.push 方法来切换路由
    }
  },
}
</script>

<style scoped lang="less">
.footerNavBox { 
  display: flex;
  justify-content: space-around;
  text-align: center;
  font-size: 0.38rem;
  padding: 0.1rem 0;
  background: white;
}
</style>